import { ContextoAcesso } from '../../../core/acesso/acesso.model';

export interface NavigationItem {
  label: string;
  icon: string;
  route?: string;
  links?: NavigationItem[];
  exigeIdentificacao?: boolean;
  capacidadeNavegacao?: 'auditoria';
  testId?: string;
}

export const NAVIGATION_ITEMS: NavigationItem[] = [
  { label: 'Início', icon: 'home', route: '/home', testId: 'navigation-home' },
  { label: 'Insumos', icon: 'container', route: '/consulta-insumos' },
  { label: 'Serviços', icon: 'tool', route: '/consulta-servicos' },
  { label: 'Autorização (Gerente)', icon: 'team', route: '/autorizacoes-gerenciais', exigeIdentificacao: true },
  {
    label: 'Planilhas',
    icon: 'file-excel',
    exigeIdentificacao: true,
    links: [
      { label: 'Gestão de Orçamentos', icon: 'file-excel', route: '/gestao-orcamentos' },
      { label: 'Painel gerencial', icon: 'bar-chart', route: '/gestao-orcamentos/painel-gerencial' }
    ]
  },
  { label: 'Contratações', icon: 'file-text', route: '/contratacoes', exigeIdentificacao: true },
  { label: 'Serv. Esp.', icon: 'tool', route: '/catalogo-especial', exigeIdentificacao: true }
];

/** Apresentação nunca é decisão de entrada de módulo. */
export function filtrarNavegacao(itens: NavigationItem[], contexto: ContextoAcesso | null): NavigationItem[] {
  return itens
    .filter(item => (!item.exigeIdentificacao || !!contexto)
      && (!item.capacidadeNavegacao || contexto?.capacidadeNavegacao[item.capacidadeNavegacao] === true))
    .map(item => item.links ? { ...item, links: filtrarNavegacao(item.links, contexto) } : item);
}
